import { ApiResponse, ApisauceInstance } from 'apisauce'
import { Instance } from 'mobx-state-tree'
import { MagicLinkPayload } from '../../models/MagicLinkPayload'
import { MagicLinkResponse } from '../../models/MagicLinkResponse'
import { AccessCodeDetailResponse } from '../../models/response-models/accessCodeDetails'
import { handleResponse } from '../handleResponse'
import { ContentMetadata } from '../../models/UserQuiz'

export const GameApi = {
  apisauce: {} as ApisauceInstance,

  /**
   * Start quiz
   */
  startQuiz: async (id: number, metadata: typeof ContentMetadata) => {
    const response: ApiResponse<any> = await GameApi.apisauce.post(`/game/${id}/start/`, metadata)
    return handleResponse(response)
  },

  /**
   * Start reinforcement
   */
  startReinforcement: async (topic_id?: number) => {
    const payload = topic_id ? { topic_id } : {}
    const response: ApiResponse<any> = await GameApi.apisauce.post('/game/start/', payload)
    return handleResponse(response)
  },

  /**
   * Start assessment
   */
  startAssessment: async (quiz_id: number, metadata: typeof ContentMetadata) => {
    const response: ApiResponse<any> = await GameApi.apisauce.post(
      `/game/assessment/${quiz_id}/start/`,
      metadata,
    )
    return handleResponse(response)
  },

  /**
   * Submit quiz answers
   */
  submitAnswers: async (payload) => {
    const response: ApiResponse<Instance<typeof MagicLinkResponse>> = await GameApi.apisauce.post(
      `game/answers/`,
      payload,
    )
    return handleResponse(response)
  },

  /**
   * Get quiz review / results
   */
  getReview: async (result_id: any, user_id: any, topic_id: any) => {
    const query = topic_id
      ? new URLSearchParams({ result_id, user_id, topic_id })
      : new URLSearchParams({ result_id, user_id })

    const response: ApiResponse<any> = await GameApi.apisauce.get(
      `/game/post_quiz_review/?${query.toString()}`,
    )
    return handleResponse(response)
  },
}
